import { type BrandedSearchPageCollection, type GTM, type LinkCard } from '@vakantiesnl/types';

import { basicGTMV2Event } from './basicGTMV2Event';

export const loadedPromotions = (source: string, promotions: BrandedSearchPageCollection[]): GTM.GTMEvent => {
	const mappedPromotions: {
		row: number;
		title: string;
		tiles: { position: number; title: string; url: string }[];
	}[] = [];

	promotions.forEach((promoCollection: BrandedSearchPageCollection, row: number) => {
		mappedPromotions[row] = {
			row: row + 1,
			title: promoCollection.title,
			tiles: [],
		};

		promoCollection.brandedsearchpages.forEach((promoCard: LinkCard, position: number) => {
			mappedPromotions[row].tiles.push({
				position: position + 1,
				title: promoCard.title,
				url: promoCard.slug,
			});
		});
	});

	return {
		event: 'promotions.ready',
		event_value: {
			value_type: 'promotions',
			source,
			action: 'load',
			promotions: mappedPromotions,
		},
	};
};

export const clickPromotion = (position: number, title: string): GTM.GTMEventV2 =>
	basicGTMV2Event({
		type: 'action',
		organism: 'promotions',
		molecule: 'promotion_card',
		atom: 'link',
		action: 'click',
		label: null,
		page_type: 'homePage',
		sub_page: 'null',
		value: {
			promotion_card_title: title,
			position: position + 1,
		},
	});
